var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.3508C10.6925 15.3508 8.8075 13.4767 8.8075 11.1583C8.8075 8.83999 10.6925 6.97665 13 6.97665C15.3075 6.97665 17.1925 8.85082 17.1925 11.1692C17.1925 13.4875 15.3075 15.3508 13 15.3508ZM13 8.60165C11.5917 8.60165 10.4325 9.74999 10.4325 11.1692C10.4325 12.5883 11.5808 13.7367 13 13.7367C14.4192 13.7367 15.5675 12.5883 15.5675 11.1692C15.5675 9.74999 14.4083 8.60165 13 8.60165Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.6567C11.3967 24.6567 9.78251 24.05 8.52584 22.8475C5.33001 19.7708 1.79834 14.8633 3.13084 9.02416C4.33334 3.72666 8.95918 1.35416 13 1.35416C13 1.35416 13 1.35416 13.0108 1.35416C17.0517 1.35416 21.6775 3.72666 22.88 9.03499C24.2017 14.8742 20.67 19.7708 17.4742 22.8475C16.2175 24.05 14.6033 24.6567 13 24.6567ZM13 2.97916C9.84751 2.97916 5.79584 4.65832 4.72334 9.38166C3.55334 14.4842 6.76001 18.8825 9.66334 21.6667C11.5375 23.4758 14.4733 23.4758 16.3475 21.6667C19.24 18.8825 22.4467 14.4842 21.2983 9.38166C20.215 4.65832 16.1525 2.97916 13 2.97916Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.06268bf7769c655adceb0dd0e5d3ca78.svg";
export { ForwardRef as ReactComponent };